import React, {useState, useEffect, useContext, useLayoutEffect} from 'react';
import {ApiContext} from '../App';
import {useSDK} from "@metamask/sdk-react";
import {useNavigate} from "react-router-dom";

interface Slide {
    vType: string;
    videoSrc: string;
    imgSrc: string;
    imgSrcMobile: string;
    pcMoblie: boolean;
    title: string;
    link: string;
    footerClass: string;
    footerText: string;
    buttonImg: string;
    buttonImgPath: string;
    buttonImg2Path: string;
    buttonImg3Path: string;
    buttonImg4Path: string;
    sellYN: string;
}

interface SectionLandProps {
    bg_img3: String;
}

interface isPopupProps {
    isOpen: boolean;
    onClose: () => void;
}

const SectionLand: React.FC<SectionLandProps> = ({bg_img3}) => {
    const apiUrl = useContext(ApiContext);
    const [slides, setSlides] = useState<Slide[]>([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const {sdk, connected, connecting, provider, chainId} = useSDK();
    const navigate = useNavigate();

    // function isSmartphone() {
    //     const userAgent = navigator.userAgent.toLowerCase();
    //
    //     // 스마트폰 기기에 해당하는 키워드 (태블릿 제외)
    //     const smartphoneKeywords = ["iphone", "ipod", "blackberry", "windows phone", "webos"];
    //
    //     // 안드로이드 태블릿 감지 (Android인데 Mobile 키워드가 없으면 태블릿)
    //     const isAndroidTablet = userAgent.includes("android") && !userAgent.includes("mobile");
    //
    //     // 아이패드 감지 (iPadOS 13 이상 대응)
    //     const isIPad = /ipad/.test(userAgent) ||
    //         (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    //
    //     // 태블릿 감지 (아이패드 + 안드로이드 태블릿)
    //     const isTablet = isIPad || isAndroidTablet;
    //
    //     // 스마트폰만 true (태블릿과 PC는 false)
    //     return !isTablet && (smartphoneKeywords.some(keyword => userAgent.includes(keyword)) ||
    //         (userAgent.includes("android") && userAgent.includes("mobile")));
    // }

    function isSmartphone() {
        const userAgent = navigator.userAgent.toLowerCase();

        // 스마트폰 기기에 해당하는 키워드 (태블릿 제외)
        const smartphoneKeywords = ["iphone", "ipod", "blackberry", "windows phone", "webos"];

        // 안드로이드 태블릿 감지 (Android인데 Mobile 키워드가 없으면 태블릿)
        const isAndroidTablet = userAgent.includes("android") && !userAgent.includes("mobile");

        // 아이패드 감지 (iPadOS 13 이상 대응)
        const isIPad = /ipad/.test(userAgent) ||
            (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

        // 태블릿 감지 (아이패드 + 안드로이드 태블릿)
        const isTablet = isIPad || isAndroidTablet;

        // 화면 너비가 768px 이하이면 모바일로 간주
        const isSmallScreen = window.innerWidth <= 767;

        // 스마트폰만 true (태블릿과 PC는 false), 또는 화면이 작은 경우도 true
        return isSmallScreen || (!isTablet && (smartphoneKeywords.some(keyword => userAgent.includes(keyword)) ||
            (userAgent.includes("android") && userAgent.includes("mobile"))));
    }


    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const response = await fetch(`${apiUrl}/api/land/list`);
                const result = await response.json();

                if (result.code == 200) {

                    const fetchedSlides = result.data.map((item: any) => ({
                        vType: item.detailImagePath ? 'image' : 'video',
                        videoSrc: item.detailImagePath || '/video/bellyVideo.gif',
                        imgSrc: item.backgroundImgPath,
                        imgSrcMobile: item.backgroundImgMobilePath,
                        pcMoblie: item.pcMoblie,
                        title: item.title,
                        link: item.link,
                        footerClass: 'green_bg',
                        footerText: 'A calm, relaxing resort where you can unwind overlooking the ocean in Bellyland.',
                        buttonImg: '/image/green_btn.png',
                        buttonImgPath: item.buttonImgPath,
                        buttonImg2Path: item.buttonImg2Path,
                        buttonImg3Path: item.buttonImg3Path,
                        buttonImg4Path: item.buttonImg4Path,
                        sellYN: item.sellYN
                    }));

                    setSlides(fetchedSlides);
                } else {
                    console.error('Error fetching data:', result.code);
                }
            } catch (error) {
                console.error('Failed to fetch slides:', error);
            }
        };

        fetchSlides();
    }, [apiUrl]);

    const totalSlides = slides.length;

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
    };

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev === totalSlides - 1 ? 0 : prev + 1));
    };

    const connect = async () => {
        // @ts-ignore
        await sdk?.init();
        try {
            const accounts = await sdk?.connect();

            if (accounts?.[0]) {
                localStorage.setItem('MetaMask', accounts?.[0]);
                navigate('/merge');
            }
        } catch (err) {
            console.warn("failed to connect..", err);
        }
    };

    const isOpenPopup = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            connect();
    };

    return (
        <div id="land" style={{backgroundImage: `url(${bg_img3})`}}>
            <div className="modal-overlay"></div>
            <div className="areaModal modal" role="dialog" aria-modal="true">
                <div className="modal-dialog modal-dialog-centered pt65" role="document">
                    <div className="modal-content min-h-auto none_bg">
                        <button className="modal-close-btn w-ba mt100">
                            <img src="/image/black_X.png" alt="Close"/>
                        </button>
                        <div className="modal-panel w-100">
                            <div className="slide-container">
                                {slides.map((slide, index) => (
                                    <div
                                        className={`slide ${currentSlide === index ? 'active' : ''}`}
                                        key={index}
                                    >
                                        <div className="modal-body">
                                            <div className="p_area">
                                                <div className="cristal">
                                                    {/*pcMoblie*/}
                                                    <img src={slide.videoSrc} alt={slide.title} width="440px"
                                                         height="440px"/>
                                                </div>
                                                <div
                                                    className={`bg b0${index + 1}`}
                                                    style={{
                                                        backgroundImage: `url(${!isSmartphone() ? slide.imgSrc : slide.imgSrcMobile})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                    }}
                                                ></div>
                                                <div className="cha_ico">
                                                    <img
                                                        src={`/image/${index + 1 < 10 ? `0${index + 1}` : index + 1}s.png`}
                                                        alt={slide.title}
                                                    />
                                                </div>
                                                {/*<h1>{slide.title}</h1>*/}
                                                <div className={"land_btn_container"}>
                                                    <button
                                                        className="event_btn land_btn"
                                                        onClick={() => (window.location.href = slide.link!)}
                                                        // onClick={() => {alert('실행!!!');}}
                                                    >
                                                        {/*<img src={slide.buttonImgPath} alt="Next"/>*/}
                                                        <img
                                                            src={`${!isSmartphone() ? slide.buttonImgPath : slide.buttonImg3Path}`}
                                                            alt="Next"/>

                                                    </button>
                                                    <button
                                                        className="event_btn land_btn"
                                                        style={slide.sellYN === 'N' ? {display: 'none'} : undefined}
                                                        onClick={(event) => handleButtonClick(event)}
                                                    >
                                                        {/*<img src={slide.buttonImg2Path} alt="Next"/>*/}
                                                        <img
                                                            src={`${!isSmartphone() ? slide.buttonImg2Path : slide.buttonImg4Path}`}
                                                            alt="Next"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {/*<div className={`modal-footer ${slide.footerClass}`}>*/}
                                        {/*  <p>{slide.footerText}</p>*/}
                                        {/*  <button*/}
                                        {/*    className="event_btn"*/}
                                        {/*    onClick={() => (window.location.href = slide.link!)}*/}
                                        {/*  >*/}
                                        {/*    <img src={slide.buttonImg} alt="Next" />*/}
                                        {/*  </button>*/}
                                        {/*</div>*/}
                                    </div>
                                ))}
                            </div>
                            <div className="slide-navigation">
                                <button className="prev-slide" onClick={prevSlide}>
                                    <img src="/image/land_prev.png" alt="Previous Slide"/>
                                </button>
                                <button className="next-slide" onClick={nextSlide}>
                                    <img src="/image/land_next.png" alt="Next Slide"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen && <ConnectPopup isOpen={isOpen} onClose={closeModal}/>}
        </div>
    );
};

const ConnectPopup: React.FC<isPopupProps> = ({isOpen, onClose}) => {


    return (
        <>
            <div className="modal-overlay"></div>

            <div className="section4-Modal" tabIndex={-1} role="dialog" aria-modal="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content min-h-auto bg_white" style={{border: '3px solid #00142D'}}>
                        <button className="modal-close-btn2 w-ba">
                            <img src="/image/close.png" alt="Close" onClick={onClose}/>
                        </button>
                        <div className="wallbody mergeModal openingModal">
                            <div className="modal-body">
                                {/*<center><img src="/image/Resort_ice_cream.png" alt="Connect Wallet" className='iceCream' /></center>*/}
                                <p className="wall_ment merge_ment"
                                   style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                    <h5 className={"opening"}>Opening Soon!</h5>
                                    <p className={"line"}>You can merge Pudgy characters </p>
                                    <p className={"line"}>into Bellyland NFT after you received</p>
                                    <p className={"line"}>the physical product. The opening </p>
                                    <p className={"line"}>alert will be on Bellyland X in April.</p>
                                    {/*<p className={"line"}>into Bellyland NFT starting in February.</p>*/}
                                    {/*<p className={"line"}> Details will be uploaded</p>*/}
                                    {/*<p className={"line"}>in Bellyland and Pudgy Penguins X.</p>*/}
                                </p>
                                <button className='modal-btn btn_check'
                                        onClick={onClose}
                                    // onClick={handleButtonClick}
                                        style={{
                                            width: '125px',
                                            height: '58px',
                                            borderRadius: '15px',
                                            border: '2px solid #00142d',
                                            backgroundColor: '#477DFD',
                                            color: 'white',
                                            fontSize: '16px',
                                            boxShadow: '7px 8px 0px rgba(0, 0, 0, 1.2)'
                                        }}
                                >
                                    <img className='imgCheck' src='/image/check_2.png'
                                         style={{display: 'flex', marginLeft: '60px'}}/>

                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionLand;
